// extracted by mini-css-extract-plugin
export default {"mainArticle":"GR0dI","poster":"ziysJ","infoBlock":"PBFXc","recommend":"fzcLO","title":"vpqXe","text":"mn16r","buttonRead":"YDGV0"};